import axios from "axios"
import { useEffect, useState } from "react"
import { apiKey } from "../config/config"
import { ToastContainer, toast } from "react-toastify"

function ContractHeader({ lang }) {
    const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
        ?.admin
        ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
        : null;
    const branchId = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
        ?.admin
        ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).branch_id
        : null;
    const [contractHeader, setContractHeader] = useState({
        line_1: "",
        line_2: "",
        line_3: ""
    });
    const handleSubmit = (e) => {
        e.preventDefault();
        axios.post(`${apiKey}/contract-header/`, {
            header_lines: JSON.stringify(contractHeader)
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(res => {
            toast.success(res.data.message)
        }).catch(err => {
            toast.error(err.message)
        })

    }
    useEffect(() => {
        axios.get(`${apiKey}/contract-header`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(res => {
            setContractHeader(JSON.parse(res.data.data[0].header_lines))
        }).catch(err => {
            console.error(err);
        })
    }, [branchId, token])
    return (
        <div>
            <main className="main" id="main">
                <ToastContainer position="bottom-right" autoClose={5000} theme="colored" />

                <div className="pagetitle">
                    <h1>{lang.General_Management || "General Management"}</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
                                    <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
                                </svg>
                            </li>
                            <li className="breadcrumb-item">{lang["Contract Header"] || "Contract Header"}</li>
                            <li className="breadcrumb-item active">{lang["Contract Header"] || "Contract Header"}</li>
                        </ol>
                    </nav>
                </div>
                <section>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex mt-3 mb-3">
                                        <h4 className="headingh4 fw-bold">{lang["Contract Header"] || "Contract Header"}</h4>
                                    </div>

                                    <form
                                        onSubmit={handleSubmit}
                                    >
                                        <div className="d-flex mt-3 mb-3 justify-content-end">
                                            <button type="submit" className="btn-save">
                                                {lang.Save_And_Publish || "Save & Publish"}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn-cancel ms-4"
                                                data-bs-toggle="modal"
                                                data-bs-target="#goodsverticalycenteredexpense"
                                            >
                                                {lang.Add_Header || "Add Header"}
                                            </button>
                                        </div>

                                        <div className="row mb-3 d-flex justify-content-center">
                                            <div className="col-lg-4">
                                                <label htmlFor="line_1" className="w-100">
                                                    <span style={{ fontSize: "14px" }}>{lang['Line 1'] || "Line 1"}:</span>
                                                    <input

                                                        className="form-control"
                                                        value={contractHeader.line_1}
                                                        onChange={(e) => setContractHeader({ ...contractHeader, line_1: e.target.value })}
                                                        required
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                        <div className="row mb-3 d-flex justify-content-center">
                                            <div className="col-lg-4">
                                                <label htmlFor="line_2" className="w-100">
                                                    <span style={{ fontSize: "14px" }}>{lang['Line 2'] || "Line 2"}:</span>
                                                    <input

                                                        className="form-control"
                                                        value={contractHeader.line_2}
                                                        onChange={(e) => setContractHeader({ ...contractHeader, line_2: e.target.value })}
                                                        required
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                        <div className="row mb-3 d-flex justify-content-center">
                                            <div className="col-lg-4">
                                                <label htmlFor="line_3" className="w-100">
                                                    <span style={{ fontSize: "14px" }}>{lang['Line 3'] || "Line 3"}:</span>
                                                    <input

                                                        className="form-control"
                                                        value={contractHeader.line_3}
                                                        onChange={(e) => setContractHeader({ ...contractHeader, line_3: e.target.value })}
                                                        required
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    )
}

export default ContractHeader